module.exports = __webpack_public_path__ + "static/media/season-img1.0f285f36.jpg";